import Vue from 'vue'
import store from './store'
import axios from 'axios'
import { HOST } from './host'
import router from './router'
import App from './components/App'
import _g from './global'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

axios.defaults.baseURL = HOST
axios.defaults.timeout = 1000 * 30
axios.defaults.headers['Content-Type'] = 'application/json'
new Vue({
  router,
  store,
  template: '<App/>',
  components: { App }
}).$mount('#app')
 
window.axios = axios
window._g = _g
const bus = new Vue()
window.bus = bus


// WEBPACK FOOTER //
// ./src/main.js